const AUTH_PATH_PREFIXES = ['/t-login', '/super-login', '/forgot-password', '/register', '/login', '/yasal']

export function isAuthPath(pathname: string | null): boolean {
  if (!pathname) return false
  return AUTH_PATH_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`))
}

/** Mesaj paneli SuperAdmin modu: /sa-* rotasında veya eczane oturumu olmayan superadmin. */
export function isChatPanelSuperAdmin(pathname?: string | null): boolean {
  if (pathname?.startsWith('/sa-')) return true
  return readSuperAdminSession()
}

export function readSuperAdminSession(): boolean {
  if (typeof window === 'undefined') return false
  try {
    // Aktif eczane oturumu varsa eczane kullanıcısıdır; eczane içi sohbet ve tam panel görünür.
    if (localStorage.getItem('tenantId')) return false
    const raw = localStorage.getItem('opas_user')
    if (!raw) return false
    const user = JSON.parse(raw) as { role?: string }
    return user.role === 'superadmin'
  } catch {
    return false
  }
}

/** SuperAdmin panel rotasında mı (eczane bağlamı yok). */
export function isSuperAdminPanelPath(pathname: string | null | undefined): boolean {
  return Boolean(pathname?.startsWith('/sa-'))
}

/**
 * Tenant oturum yöneticisi (401 yakalama, refresh, idle logout) bu bağlamda çalışmamalı.
 * SuperAdmin JWT ile eczane API'leri 401 döner; yanlışlıkla «oturum doldu» tetiklenmesin.
 */
export function shouldUseTenantSessionHandling(pathname?: string | null): boolean {
  if (typeof window === 'undefined') return true
  const path = pathname ?? window.location.pathname
  if (isSuperAdminPanelPath(path)) return false
  if (readSuperAdminSession()) return false
  return true
}

/** Tenant veya SuperAdmin oturumunda OPAS mesaj paneli mount edilir. */
export function shouldEnableChatPanel(pathname: string | null): boolean {
  if (isAuthPath(pathname)) return false
  if (pathname?.startsWith('/sa-')) return true
  if (typeof window === 'undefined') return false
  try {
    if (localStorage.getItem('tenantId')) return true
    if (readSuperAdminSession()) return true
  } catch {
    return false
  }
  return false
}
